import {usePanelsTemplate, usePanelsUpdate} from 'Event/template/Panels'
import {generateHashId} from 'lib/crypto/hash'
import {useAddTranslation, useTranslationLanguage} from 'Event/LanguageProvider'
import {parseVariables} from 'lib/template'

export function useDuplicateAgenda() {
  const template = usePanelsTemplate()
  const save = usePanelsUpdate()
  const addTranslation = useAddTranslation()
  const targetLanguage = useTranslationLanguage()

  return (sourceId: string) => {
    const source = template.agendaList.items[sourceId]
    if (!source) {
      return
    }

    const position = Object.keys(template.agendaList.items).length + 1
    const translations =
      template.localization?.translations?.[targetLanguage] ?? {}

    const resolve = (value: string | null | undefined) => {
      const [variable] = parseVariables(value ?? '')
      return variable ? translations[variable] ?? '' : value ?? ''
    }

    return generateHashId([
      'panels',
      'agenda_list',
      position.toString(),
      Date.now().toString(),
      Math.random().toString(),
    ]).then((id) => {
      const componentId = `agenda_item_${id}`

      save({
        localization: addTranslation({
          [`${componentId}_text`]: resolve(source.text),
          [`${componentId}_description`]: resolve(source.description),
          [`${componentId}_link`]: resolve(source.link),
        }),
        agendaList: {
          items: {
            [id]: {
              ...source,
              position,
              text: `{{${componentId}_text}}`,
              description: `{{${componentId}_description}}`,
              link: `{{${componentId}_link}}`,
            },
          },
        },
      })
    })
  }
}
